var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6977_19348)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.7571,
    cy: 22.5256,
    r: 22,
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7571 22.5256C25.415 22.5256 27.5696 20.371 27.5696 17.7131C27.5696 15.0553 25.415 12.9006 22.7571 12.9006C20.0992 12.9006 17.9446 15.0553 17.9446 17.7131C17.9446 20.371 20.0992 22.5256 22.7571 22.5256ZM22.7571 14.2756C24.6556 14.2756 26.1946 15.8147 26.1946 17.7131C26.1946 19.6116 24.6556 21.1506 22.7571 21.1506C20.8586 21.1506 19.3196 19.6116 19.3196 17.7131C19.3196 15.8147 20.8586 14.2756 22.7571 14.2756ZM29.6321 28.7131V32.1506H28.2571V28.7131C28.2571 27.8015 27.8949 26.9271 27.2503 26.2825C26.6056 25.6378 25.7313 25.2756 24.8196 25.2756H20.6946C18.7961 25.2756 17.2571 26.8147 17.2571 28.7131V32.1506H15.8821V28.7131C15.8821 26.0553 18.0367 23.9006 20.6946 23.9006H24.8196C27.4775 23.9006 29.6321 26.0553 29.6321 28.7131Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6977_19348"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75708,
    y: 0.525635,
    width: 44,
    height: 44,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/DefaultAvatar.4f75561f9dcc83f4f8876de8000fdc33.svg";
export { ForwardRef as ReactComponent };